import { cn } from "@/lib/utils";
import { statisticsSidebarSurfaceCardClassName } from "../Statistics/components/statisticsShadcnCardShell";

/** University list / course cards — sidebar surface in dark mode (matches Strategies / Reports). */
export const universityCourseCardClassName = cn(
  "flex h-full flex-col gap-0 overflow-hidden !rounded-[6px] border border-solid border-border bg-card p-0 text-card-foreground shadow-none !ring-0",
  "[&>img:first-child]:!rounded-t-[6px] [&_[data-university-course-thumb]]:rounded-t-[6px]",
  statisticsSidebarSurfaceCardClassName,
);

export const universityFeaturedCardClassName = cn(
  "relative w-full min-w-0 gap-0 overflow-hidden !rounded-[6px] border border-solid border-border bg-card p-0 text-card-foreground shadow-none !ring-0",
  statisticsSidebarSurfaceCardClassName,
);

export const universityCourseThumbClassName =
  "h-[120px] w-full shrink-0 rounded-t-[6px] object-cover object-center";

export const universityCourseThumbFallbackClassName =
  "h-[120px] w-full shrink-0 rounded-t-[6px] bg-cover bg-center";

export const universityCourseLessonCardClassName = cn(
  "gap-0 overflow-hidden !rounded-[6px] border border-solid border-border bg-card p-0 text-card-foreground shadow-none !ring-0",
  statisticsSidebarSurfaceCardClassName,
);
